<template>
  <BaseModal :is-open="showModal" @close="closeModal">
    <template #content>
      <div class="modal">
        <ButtonIconContextual
          icon="EF0030"
          label="Fechar"
          class="modal__icon"
          @click="closeModal"
        />

        <HelperViewContextual
          title="Custódia remunerada desativada"
          description="Seus ativos alugados estarão disponíveis em até três dia úteis."
          icon="EF0080"
          status="information"
        />
      </div>
    </template>
  </BaseModal>
</template>

<script lang="ts" setup>
import {
  BaseModal,
  ButtonIconContextual,
  HelperViewContextual
} from '@warrenbrasil/nebraska-web';

const { showModal } = defineProps({
  showModal: Boolean
});

const emit = defineEmits(['close']);

const closeModal = () => {
  emit('close');
};
</script>

<style lang="less" scoped>
.modal {
  width: 100%;
  flex: 1;
  display: flex;
  align-items: center;
  justify-content: center;
  position: relative;
  padding: 0 50px;

  &__icon {
    position: absolute;
    top: @size-spacing-x350;
    left: @size-spacing-x400;
  }
}

:deep(.scroll-shadow__content) {
  display: flex;
}

:deep(.helper-view) {
  max-width: 490px;
  width: 100%;
}

:deep(.helper-view__description) {
  max-width: 300px;
}

:deep(.helper-view__icon) {
  margin-bottom: @size-spacing-x600;
}

:deep(.helper-status--neutral .initial-avatar-icon) {
  background: @status-info-background;
}

:deep(.initial-avatar-icon .svg-icon) {
  color: @status-info;
}

:deep(.base-modal--wrapper.size-sm) {
  max-width: 592px;
  max-height: 582px;
  width: 592px;
  height: 582px;
}
</style>
